import { render, staticRenderFns } from "./HomeGlobal.vue?vue&type=template&id=648eeb97&"
import script from "./HomeGlobal.vue?vue&type=script&lang=js&"
export * from "./HomeGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports